
    import Component from "vue-class-component";
    import Vue from "vue";
    import {Prop} from "vue-property-decorator";
    import {ContactInfoViewModel, DocumentDeliveryMethodModel, PickUpDeliveryMethodModel, PostalDeliveryMethodModel} from "@/api-client";
    import { isNullOrWhiteSpace } from "@/extensions/string.helpers";

    @Component
    export default class DeliveryMethodSummary extends Vue {
        @Prop({required: true})
        deliveryMethod!: DocumentDeliveryMethodModel | null;
        
        @Prop({required: true})
        model!: ContactInfoViewModel | null;

        deliveryMethods = {
            pickup: PickUpDeliveryMethodModel,
            postal: PostalDeliveryMethodModel
        };
        

        get fullAddress() {
            if (this.model) {
                const flat = `${(isNullOrWhiteSpace(this.model.address.flatNumber) ? `` : `- ${this.model.address.flatNumber}`)}`;
                const district = isNullOrWhiteSpace(this.model.address.district) ? `` : `, ${this.model.address.district}`;
                const municipality = isNullOrWhiteSpace(this.model.address.municipality) ? `` : `, ${this.model.address.municipality}`;
                const province = isNullOrWhiteSpace(this.model.address.province) ? `` : `, ${this.model.address.province}`;
                const postalCode = isNullOrWhiteSpace(this.model.address.postalCode) ? `` : `, ${this.model.address.postalCode}`;
                const streetAndHouse = this.model.address.street === this.model.address.houseNumber
                    ? this.model.address.street
                    : `${this.model.address.street} ${this.model.address.houseNumber}`;

                return `${streetAndHouse}${flat}${district}${municipality}${province}${postalCode}`;
            }
            return "";
        }

        translateDeliveryMethod() {
            if (this.deliveryMethod instanceof PickUpDeliveryMethodModel) {
                return this.$ls.Applications_Delivery_DeliveryMethod_Pickup;
            }
            if (this.deliveryMethod instanceof PostalDeliveryMethodModel) {
                return this.$ls.Applications_Delivery_DeliveryMethod_ByPost;
            }
            return this.$ls.Applications_Delivery_DeliveryMethod_Digital;
        }
    }
